import { Card, Icon, Layout, Tag, Text } from '@loadsmart/miranda-react'

import { ALL_TRACKING_PROVIDERS, type TrackingMethod } from '../../../domain/Tracking'
import TrackingMethodCard from './TrackingMethodCard'

export type TrackingMethodStepProps = {
  readonly selectedMethod?: TrackingMethod
  readonly onSelectMethod: (method: TrackingMethod) => void
}

export default function TrackingMethodStep({
  selectedMethod,
  onSelectMethod,
}: TrackingMethodStepProps) {
  return (
    <Card collapsible>
      <Card.Title
        leading={selectedMethod ? <Icon name="check" color="color-success-60" /> : undefined}
      >
        1. Tracking method
        {selectedMethod && (
          <Tag variant="neutral" size="small">
            {selectedMethod}
          </Tag>
        )}
      </Card.Title>
      <Card.Subtitle>What tracking method best fits your company needs?</Card.Subtitle>
      <Card.Divider />
      <Card.Body>
        <Layout.Stack gap="spacing-4">
          <Text variant="body-md" color="color-text-tertiary">
            Select the tracking method
          </Text>
          <Layout.Grid gap="spacing-2" minColumnWidth="220px">
            {ALL_TRACKING_PROVIDERS.map(method => (
              <TrackingMethodCard
                key={method}
                method={method}
                onClick={() => onSelectMethod(method)}
                selected={selectedMethod === method}
              />
            ))}
          </Layout.Grid>
        </Layout.Stack>
      </Card.Body>
    </Card>
  )
}
